export default function Toggle({ checked, onChange, text }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={`relative w-12 h-6 rounded-full transition-colors duration-300 ${
        checked ? 'bg-blue-600' : 'bg-gray-300'
      } focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2`}
    >
      <span
        className={`absolute left-0 top-0 h-6 w-6 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
          checked ? 'translate-x-6' : 'translate-x-0'
        }`}
      />
      <span className="sr-only">{text}</span>
    </button>
  );
}
